import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import { useShouldShowConsults } from 'hooks/useShouldShowConsultLink';

import {
  ButtonColors,
  ButtonSizes,
  Card,
  LinkButton,
  Typography,
} from 'components';

import consultPcSvg from 'assets/images/consults/consult-pc-mobile.svg';

import styles from './ConsultWidget.module.scss';

type ConsultWidgetProps = {
  title?: string;
};

export const ConsultWidget = ({ title = 'Need help?' }: ConsultWidgetProps) => {
  const { currentKit, currentKitId } = useCurrentKitAndTinyAccount();
  const shouldShowConsultLink = useShouldShowConsults(currentKit);

  if (!currentKit || !shouldShowConsultLink) {
    return null;
  }

  return (
    <Card variant='wrapper' className={styles.card}>
      <div className={styles.content}>
        <div className={styles.imageContainer}>
          <img className={styles.image} src={consultPcSvg} alt='Video call' />
        </div>
        <div className={styles.rightColumn}>
          <div className={styles.textContainer}>
            <Typography
              variant='body-m'
              serif
              className={styles.textTitle}
              responsive
            >
              {title}
            </Typography>
            <Typography variant='body-xs'>
              Schedule a call with one of our specialists.
            </Typography>
          </div>

          <LinkButton
            label='Schedule call'
            href={`/results/${currentKitId}/consults/select-method`}
            color={ButtonColors.WHITE}
            size={ButtonSizes.S}
            className={styles.scheduleButton}
          />
        </div>
      </div>
    </Card>
  );
};
